import React from "react";

import TwoPanels from "./TwoPanels";
import Text from "./Text";
import { blueHeader } from "./styles";

const CostOfDebt = ({ metrics }) => (
  <TwoPanels title1="Cost of Debt & Equity" title2="">
    <fragment>
      <Text>
        Your cost of debt is the weighted average financing costs that you incur
        from borrowing money across different lenders. It is the interest
        charges. Your cost of debt is now{" "}
        {(metrics["Bond Yield"] * 100).toFixed(2)}%.
      </Text>
      <Text>
        Your cost of equity is now{" "}
        {(metrics["Required Rate of Return"] * 100).toFixed(2)}%.
      </Text>
      <Text>
        Your cost of equity is the required rate of return that GBorGH Ventures
        (your equity investor) expects plus a spread if you have any debt.
      </Text>
      <Text>
        <b>Note</b>: If your current costs of equity is higher than investors’
        initial required return, then investors are worried about your company
        having financial distress.
      </Text>
      <Text>
        In this game, financial distress is driven by your debt to capital
        ratio. For more details, please reviewing the financing section of the
        MG Business Case.
      </Text>
    </fragment>
    <fragment>
      <h3 style={blueHeader}>
        Weighted Average
        <br />
        Interest Rate
      </h3>
      <Text
        style={{ fontSize: "30px", textAlign: "center", marginTop: "1.5em" }}
      >
        {(metrics["Bond Yield"] * 100).toFixed(2)}%
      </Text>
      <h3 style={blueHeader}>Initial Required Rate of Return</h3>
      <Text
        style={{ fontSize: "30px", textAlign: "center", marginTop: "1.5em" }}
      >
        {(metrics["Equity Cost of Capital"] * 100).toFixed(2)}%
      </Text>
    </fragment>
  </TwoPanels>
);

export default CostOfDebt;



// WEBPACK FOOTER //
// ./src/components/analysis/CostOfDebt.js